'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { createIdGuard } from '@s7/base';
import { useId, useUncontrolled } from '@s7/hooks';
import { isArray } from '@s7/utils';
import { ACCORDION_ERRORS } from '../Accordion.errors.js';
import { AccordionContextProvider } from './Accordion.context.js';

function AccordionProvider(props) {
    var children = props.children, multiple = props.multiple, value = props.value, defaultValue = props.defaultValue, onChange = props.onChange, id = props.id, loop = props.loop, transitionDuration = props.transitionDuration, disableChevronRotation = props.disableChevronRotation, chevronPosition = props.chevronPosition, chevronSize = props.chevronSize, chevron = props.chevron, classNames = props.classNames, styles = props.styles, variant = props.variant, theme = props.theme, labelProps = props.labelProps;
    var uid = useId(id);
    var _useUncontrolled = useUncontrolled({
        value: value,
        defaultValue: defaultValue,
        finalValue: multiple ? [] : null,
        onChange: onChange
    }), _value = _useUncontrolled[0], handleChange = _useUncontrolled[1];
    var isItemActive = function(itemValue) {
        return isArray(_value) ? _value.includes(itemValue) : itemValue === _value;
    };
    var handleItemChange = function(itemValue) {
        var nextValue = isArray(_value) ? _value.includes(itemValue) ? _value.filter(function(selectedValue) {
            return selectedValue !== itemValue;
        }) : [].concat(_value, [
            itemValue
        ]) : itemValue === _value ? null : itemValue;
        handleChange(nextValue);
    };
    var context = {
        isItemActive: isItemActive,
        onChange: handleItemChange,
        getControlId: createIdGuard("" + uid + "-control", ACCORDION_ERRORS.value),
        getRegionId: createIdGuard("" + uid + "-panel", ACCORDION_ERRORS.value),
        transitionDuration: transitionDuration,
        disableChevronRotation: disableChevronRotation,
        chevronPosition: chevronPosition,
        chevronSize: chevronSize,
        chevron: chevron,
        loop: loop,
        classNames: classNames,
        styles: styles,
        variant: variant,
        theme: theme,
        labelProps: labelProps
    };
    return /*#__PURE__*/ jsx(AccordionContextProvider, {
        value: context,
        children: children
    });
}

export { AccordionProvider };
